module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-5 offset-xl-1"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-xl-5 px-0 position-relative"
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": ("/static/assets/imgs/" + _vm.imageName),
      "srcset": ("/static/assets/imgs/" + (_vm.imageName.substring(0, _vm.imageName.lastIndexOf('.'))) + "-320w" + (_vm.imageName.substring(_vm.imageName.lastIndexOf('.'))) + " 320w, /static/assets/imgs/" + (_vm.imageName.substring(0, _vm.imageName.lastIndexOf('.'))) + "-640w" + (_vm.imageName.substring(_vm.imageName.lastIndexOf('.'))) + " 640w, /static/assets/imgs/" + (_vm.imageName.substring(0, _vm.imageName.lastIndexOf('.'))) + "-960w" + (_vm.imageName.substring(_vm.imageName.lastIndexOf('.'))) + " 960w"),
      "alt": _vm.altText
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-137f8622"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
// module id = 1930
// module chunks = 5